import { organizationTypeEntityName } from '../../../../../../backend/config/classifiers/OrganizationTypeClassifier/shared';
import { organizationEntityName } from '../../../../../../backend/features/organizations/shared';
import { AppPaper } from '../../../../../../ui/components/deprecated/AppPaper';
import { useOrganizationsAuditBackendDataProvider } from '../../../../../../ui/features/organizations/hooks/useOrganizationsAuditBackendDataProvider';
import { useInvalidateState } from '../../../../../../ui/hooks/deprecated/useInvalidateState';
import { useContactManagementTranslation } from '../../../../../../ui/hooks/useContactManagementTranslation';
import { Form } from '@juvare/common-form-ui/Form';
import { AppPageHeader2 } from '@juvare/common-web-ui/AppPageHeader2';
import { FullHeightPage } from '@juvare/common-web-ui/FullHeightPage';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { PageError } from '@juvare/common-web-ui/PageError';
import { showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { EntityAudit } from '@juvare/platform-sdk-react/ui/features/audit';
import { useStorageClient, useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useOrganization } from '../../../hooks/useOrganization';
import { useOrganizationSection } from '../hooks/useOrganizationSection';
import { useOrganizationsSectionsNew } from '../hooks/useOrganizationSectionsNew';
import { OrganizationMembers } from './OrganizationMembers';
export const OrganizationSectionPage = ({ customMemberSlideoutMenuItems, customMemberDetailsComponent, }) => {
    const { t } = useContactManagementTranslation();
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    const location = useLocation();
    const { organizationId, sectionNameLowerCase } = useParams();
    const organizationResponse = useOrganization(organizationId);
    const sectionsResponse = useOrganizationsSectionsNew();
    const organization = organizationResponse.data;
    const sections = sectionsResponse.data;
    const isLoading = organizationResponse.isLoading || sectionsResponse.isLoading;
    const error = organizationResponse.error || sectionsResponse.error;
    const handleReloadOrganization = organizationResponse.mutate;
    if (organizationId && organization && sections && !error) {
        let subTitle = '';
        let sectionDetails = null;
        if (sectionNameLowerCase === 'history') {
            subTitle = t('panels.organizations.history');
            sectionDetails = (React.createElement(Box, { sx: { p: 2 } },
                React.createElement(EntityAudit, { entityIds: [organizationId], entities: [organizationEntityName], customAuditBackendDataProvider: useOrganizationsAuditBackendDataProvider })));
        }
        else {
            const section = sections.rows.find((row) => row.columns.name.toLowerCase() === sectionNameLowerCase);
            if (!section) {
                return React.createElement(PageError, { type: 'not-found' });
            }
            subTitle = section.columns.title;
            if (section.columns.key === 'members') {
                sectionDetails = (React.createElement(AppPaper, null,
                    React.createElement(OrganizationMembers, { organizationId: organizationId, onReloadOrganization: handleReloadOrganization, customMemberSlideoutMenuItems: customMemberSlideoutMenuItems, customMemberDetailsComponent: customMemberDetailsComponent })));
            }
            else {
                sectionDetails = (React.createElement(AppPaper, { contentPadding: 2, contentWidth: 800 },
                    React.createElement(SectionDetails, { organization: organization, sectionId: section.id })));
            }
        }
        return (React.createElement(FullHeightPage, { scrollable: true },
            React.createElement(AppPageHeader2, { title: t('panels.organizations.title'), subTitle: [organization.data.name, subTitle], onBack: () => navigationContext.navigate(() => { var _a; return (((_a = location.state) === null || _a === void 0 ? void 0 : _a.back) ? navigate(-1) : navigate('..')); }) }),
            sectionDetails));
    }
    else if (isLoading) {
        return React.createElement(CircularProgress, null);
    }
    else {
        return React.createElement(PageError, { error: error });
    }
};
const SectionDetails = ({ organization, sectionId }) => {
    var _a;
    const { t } = useContactManagementTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const storageClient = useStorageClient(organizationEntityName);
    const sectionResponse = useOrganizationSection(sectionId);
    const { data: organizationTypes, isLoading: organizationTypesIsLoading } = useStorageList(organizationTypeEntityName, {
        filter: [
            {
                column: 'status',
                op: '=',
                value: 'active',
            },
        ],
        limit: 1,
    });
    const section = sectionResponse.data;
    const isLoading = sectionResponse.isLoading || organizationTypesIsLoading;
    const error = sectionResponse.error;
    const { invalidateState } = useInvalidateState();
    if (isLoading && !error) {
        return React.createElement(CircularProgress, null);
    }
    if (section && !error) {
        const formParams = {
            id: organization.id,
            createdBy: organization.createdBy,
            organizationsTypeLength: (_a = organizationTypes === null || organizationTypes === void 0 ? void 0 : organizationTypes.total) !== null && _a !== void 0 ? _a : 0,
        };
        return (React.createElement(Form, { key: organization.updated, config: section.data.form, data: organization.data, formParams: formParams, changeUndefinedTopFieldsToNull: true, trackChanges: 'ask-to-save', onSubmit: (data) => {
                return storageClient.post({
                    action: 'partial-update',
                    id: organization.id,
                    data: data,
                });
            }, onSubmitSuccess: () => {
                var _a;
                showInfoSnackbar({ message: t('common.saved'), autoHideDuration: 2000 });
                if ((_a = location.state) === null || _a === void 0 ? void 0 : _a.back) {
                    invalidateState().then(() => {
                        navigate(-1);
                    });
                }
                else {
                    invalidateState().then(() => {
                        navigate({
                            pathname: '..',
                            search: new URLSearchParams({ organizationId: organization.id }).toString(),
                        }, {});
                    });
                }
            } }));
    }
    else {
        return React.createElement(PageError, { error: error });
    }
};
